import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Flex, Group, Modal, SimpleGrid, Stack, Text } from '@mantine/core';
import classes from '../Shares/Modal.module.css';
import { FavoriteGameCard } from './FavoriteGameCard';
import { GameInfoCard } from './GameInfoCard';
import { InfoStatistic } from './InfoStatistic';
import { UserInfoCard } from './UserInfoCard';
export const InfoModal: React.FC = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  const {
    i18n
  } = useLingui();
  return <Modal opened={openModal === MODAL.INFO} onClose={() => setOpenModal(null)} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.95)'
  }} size="100%" classNames={classes}>
      <Flex justify="center" w="100%">
        <Flex h="100%" align="center" maw={1320} w={{
        base: '100%',
        sm: 722,
        md: 650
      }}>
          <Stack w="100%" gap={0} pb={50}>
            <Group justify="space-between">
              <Text fz={{
              base: 20,
              sm: 18
            }} className={gunterzBold.className}>
                {i18n._('BEST SLIP')}
              </Text>
              <Text fz={{
              base: 12,
              sm: 13
            }} c="var(--text-dark)" fw={700} tt="uppercase">
                {i18n._('BET ID #8447124')}
              </Text>
            </Group>
            <GameInfoCard />
            <UserInfoCard username={'@bagholder1'} level={2} verifyLevel={3} expStart={38577} expEnd={50000}>
              <SimpleGrid cols={{
              base: 1,
              sm: 2
            }}>
                <FavoriteGameCard />
              </SimpleGrid>
            </UserInfoCard>
            <InfoStatistic />
          </Stack>
        </Flex>
      </Flex>
    </Modal>;
};